import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectCargoTags = (state: RootState) =>
  state.data.orgSettings.cargoTags;

export const selectActiveCargoTags = createSelector(selectCargoTags, (tags) =>
  tags.filter((tag) => tag.description)
);

export const selectOrgSettings = (state: RootState) => state.data.orgSettings;

export const selectHideLoadmeters = (state: RootState) =>
  state.data.orgSettings.hideLoadmeters;

export const selectHideCargoDescription = (state: RootState) =>
  state.data.orgSettings.hideCargoDescription;

export const selectHideInvoiceRef = (state: RootState) =>
  state.data.orgSettings.hideInvoiceRef;

export const selectClientRequiredOnCargos = (state: RootState) =>
  state.data.orgSettings.clientRequiredOnCargos;

export const selectEquipmentEnabled = (state: RootState) =>
  state.data.orgSettings.equipmentEnabled;

export const selectFractionsEnabled = (state: RootState) =>
  state.data.orgSettings.fractionsEnabled;

export const selectDriverShouldRegisterTimeDefaultSetting = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.showCargoTimeTrackingToDriver
);

export const selectHideCargoFromDriversDefaultSetting = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.hideCargoFromDriversDefault
);

export const selectDriverCanAddStopsDefaultSetting = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.driverCanAddExtraStopsDefault
);

export const selectDriverCanPickFromUndispatchedDefaultSetting = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.driverCanPickFromUndispatchedDefault
);

export const selectCalendarViewSettings = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.calendarViewSettings
);

export const selectCalendarViewFilledRows = createSelector(
  selectOrgSettings,
  (orgSettings) => {
    let i = 1;
    if (orgSettings.calendarViewSettings.secondRow) {
      i++;
    }
    if (orgSettings.calendarViewSettings.thirdRow) {
      i++;
    }
    return i;
  }
);

export const selectNewShipmentDateAdjustment = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.newShipmentDate
);

export const selectNewSyncedClientsVisibleToDriver = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.newSyncedCustomersVisibleToDriver
);

export const selectNewSyncedProductsVisibleToDriver = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.newSyncedProductsVisibleToDriver
);

export const selectSplitCargoTeamId = createSelector(
  selectOrgSettings,
  (orgSettings) => orgSettings.splitRouteCargoTeamId
);
